import React, { useState } from 'react';
import CatalogoPage from '../components/CatalogoPage';

const TABS = ['Tipos de Vehículo', 'Tipos de Evento'];

export default function CatalogosPage() {
  const [tab, setTab] = useState(0);

  return (
    <div>
      {/* Tabs */}
      <div style={{ display:'flex', gap:0, marginBottom:20, borderBottom:'1px solid var(--border)' }}>
        {TABS.map((t, i) => (
          <button key={i} onClick={() => setTab(i)} style={{ padding:'10px 20px', background:'none', border:'none', color: tab===i ? 'var(--accent)' : 'var(--text-muted)', borderBottom: tab===i ? '2px solid var(--accent)' : '2px solid transparent', cursor:'pointer', fontFamily:'var(--font-display)', fontSize:14, fontWeight:600, letterSpacing:0.5, textTransform:'uppercase', transition:'color 0.15s' }}>
            {t}
          </button>
        ))}
      </div>

      {tab === 0 && (
        <CatalogoPage
          title="Tipos de Vehículo"
          endpoint="/catalogos/tipos-vehiculo"
          description="Categorías de vehículos (tractocamión, remolque, etc.)"
          fields={[
            { key:'nombre', label:'Nombre', required:true, placeholder:'Ej: Tractocamión' },
            { key:'descripcion', label:'Descripción', type:'textarea', placeholder:'Descripción del tipo de vehículo' },
            { key:'icono', label:'Icono', placeholder:'truck', default:'truck' },
            { key:'activo', label:'Activo', type:'checkbox', default:true }
          ]}
        />
      )}

      {tab === 1 && (
        <CatalogoPage
          title="Tipos de Evento"
          endpoint="/catalogos/tipos-evento"
          description="Tipos de alertas que puede generar el sistema GPS"
          fields={[
            { key:'nombre', label:'Nombre', required:true, placeholder:'Ej: Exceso de Velocidad' },
            { key:'descripcion', label:'Descripción', type:'textarea', placeholder:'Descripción del tipo de alerta' },
            { key:'prioridad', label:'Prioridad', type:'select', default:'media', options:[
              {value:'baja',label:'Baja'},{value:'media',label:'Media'},{value:'alta',label:'Alta'},{value:'critica',label:'Crítica'}
            ]},
            { key:'color', label:'Color', type:'color', default:'#f59e0b' },
            { key:'activo', label:'Activo', type:'checkbox', default:true }
          ]}
        />
      )}
    </div>
  );
}
